var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasBody && _vm.hasLink)?_c('Card',_vm._b({class:[_vm.gridAlignmentClassName],attrs:{"heading":_vm.headingText,"headingLevel":_vm.headingLevel}},'Card',Object.assign({}, _vm.$props),false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }